/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const PlatformDataMappingIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Platform Data Mapping',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 36 36"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M30.328 20.005a4.988 4.988 0 0 0-6.074 3.328H10v-4.398a.5.5 0 0 0-.83-.376l-6.74 5.898a.5.5 0 0 0 0 .753l6.74 5.898a.5.5 0 0 0 .83-.377v-4.398h14.254a4.993 4.993 0 1 0 6.074-6.328ZM5.672 13.662a4.988 4.988 0 0 0 6.074-3.329H26v4.398a.5.5 0 0 0 .83.377l6.74-5.898a.5.5 0 0 0 0-.753l-6.74-5.898a.5.5 0 0 0-.83.376v4.398H11.746a4.993 4.993 0 1 0-6.074 6.329Z"
    />
  </svg>`;
};
